import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

const AdminProtectedRoute = ({ children }) => {
  const { isAdmin, isLoading } = useAuth();

  if (isLoading) {
    return (
      <div className="page-body-container">
        <div className="mx-auto px-12 text-center py-20">
          <div className="inline-block animate-spin rounded-full h-8 w-8 border-t-2 border-b-2 border-blue-500"></div>
          <p className="mt-4">Verifying access...</p>
        </div>
      </div>
    );
  }

  return isAdmin ? children : <Navigate to="/adminlogin" replace />;
};

export default AdminProtectedRoute;